import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue";
import Icon from "./Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ColumnSort',
    props: {
        column: {}
    },
    emits: [
        'toggle'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        function toggle() {
            emit('toggle', props.column);
        }
        return (_ctx, _cache) => {
            return (__props.column.sortable)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _withModifiers(toggle, ["prevent"]),
                    class: "sort",
                    href: ""
                }, [
                    (__props.column.sorted && __props.column.sortDirection === 'asc')
                        ? (_openBlock(), _createBlock(Icon, {
                            key: 0,
                            name: "sort-up",
                            "icon-style": "duotone"
                        }))
                        : (__props.column.sorted && __props.column.sortDirection === 'desc')
                            ? (_openBlock(), _createBlock(Icon, {
                                key: 1,
                                name: "sort-down",
                                "icon-style": "duotone"
                            }))
                            : (_openBlock(), _createBlock(Icon, {
                                key: 2,
                                name: "sort",
                                "icon-style": "light"
                            }))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
